export default (() => ({
    attachmentWrapper: {
        margin: '0 6px',
        width: '100%'
    }
}));
